/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

import { nanoid } from 'nanoid';
import { v4 as uuidv4, v5 as uuidv5 } from 'uuid';

export const DEFAULT_UUID_NAMESPACE = '171cd4ba-bbfd-4bb5-86e2-d8af46c0ae0b';

/**
 * Generate a UUID v4 or v5 based on the input
 * if input is true, generate a nano id
 *
 * ```ts
 * uuid(); // 1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4c1e
 * uuid('hello'); // 3d813cbb-47fb-32ba-91df-831e1593ac29
 * uuid(true); // 3d813cbb-47fb-32ba-91df-831e1593ac29
 * ```
 */
export const uuid = (strOrNano?: string | true) => {
  return strOrNano === true
    ? nanoid()
    : strOrNano
    ? uuidv5(strOrNano, DEFAULT_UUID_NAMESPACE)
    : uuidv4();
};

export default uuid;
